import { useAppSelector } from 'store/hooks'
import { geoBlockedGameCodesSelector } from 'store/modules/games/geoBlockedContentSelectors'

/**
 * PLDV-8952 — whether this game is geo-blocked for the customer's current state
 * (`location.state` from the last GetAccountInfoResponse).
 */
export function useIsGameGeoBlocked(code?: string | null) {
  const geoBlockedCodes = useAppSelector(geoBlockedGameCodesSelector)

  return Boolean(code && geoBlockedCodes?.has(code))
}
